let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4SzJh")).then(() => parcelRequire('eBrft'));